/**
 * 该文件主要用于整合各模块中需要独立显示的路由（没有任何指定layout）
 */
import defaultLayout from '../../layouts/default'
import unsubscribe from '../main/edm/unsubscribe'
import success from '../main/edm/success'

export default {
  path: '',
  component: defaultLayout,
  children: [
    {
      path: 'edm/unsubscribe',
      component: unsubscribe,
      meta: {
        activeMenu: 'edm'
      }
    },
    {
      path: 'edm/success',
      component: success,
      meta: {
        activeMenu: 'edm'
      }
    }
  ]
}
